import { render } from "./DefaultForm.vue?vue&type=template&id=3c96099e&scoped=true"
import script from "./DefaultForm.vue?vue&type=script&lang=js"
export * from "./DefaultForm.vue?vue&type=script&lang=js"

import "./DefaultForm.vue?vue&type=style&index=0&id=3c96099e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c96099e"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSelect});
